;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.product.show')
    .controller('HistoryPriceModalController', HistoryPriceModalController)

  HistoryPriceModalController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    'history'
  ]

  function HistoryPriceModalController (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    history
  ) {
    let self = this
    self.history = history

    _.extend(self, {
      // Public Attributes
      // Public Method
      selectPrice: selectPrice
    })

    function selectPrice (index) {
      self.selection === self.history[index] ? self.selection = undefined : self.selection = self.history[index]
    }
  }
})(window.angular, window._)
